import { createAsyncThunk } from '@reduxjs/toolkit'
import Player from './player-model'
import { delete_player, load_players, store_player } from './player-service'

export const LoadPlayersAsync = createAsyncThunk<any, any>(
  'composer/load/player',
  async (params: { uid: string }) => {
    return await load_players(params)
  },
)

export const CreatePlayerAsync = createAsyncThunk<any, any>(
  'composer/create/player',
  async (params: Player) => {
    return await store_player(params)
  },
)

export const DeletePlayerAsync = createAsyncThunk<any, any>(
  'composer/delete/player',
  async (params) => {
    return await delete_player(params)
  },
)
